export const formatDate = (date, short) => {
  const options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour12: false
  }

  if (!short) {
    options.hour = 'numeric'
    options.minute = 'numeric'
    options.second = 'numeric'
  }

  let formatter = new Intl.DateTimeFormat('fr', options)

  return formatter.format(date)
}

export const SMBL_TMPL = {
  rsiPeriod: 0
}
